<template>
  <div class="col-md-4">
    <div class="donation-item">
      <a
        class="donation-item__link"
        @mousedown.prevent.stop="$router.push({name: 'DonationDetail', params: {id: product.slug}})"
      >
        <div class="donation-item__img-wrapper" :title="product.title">
          <img :src="img(product.image)"  />
          <div class="donation-item__hover-arrow">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
        <div class="donation-item__body">
          <div class="donation-item__title">{{product.title}}</div>
          <div class="donation-item__short-desc">{{product.description}}</div>
        </div>
      </a>
      <div class="donation-item__footer d-flex" v-if="!product.redirect_url">
        <div class="donation-item__footer--input d-flex align-items-center">
          <input type="text" :disabled="product.changeable == 0" v-model="price" />
          <span>₺</span>
        </div>
        <div class="donation-item__footer--btn button button__red" @click="donate">BAĞIŞ YAP</div>
      </div>
      <div class="donation-item__footer d-flex" v-else>
        <div class="donation-item__footer--btn button button__red w-100" style="padding:11px" @click="redirect(product)"
        >BAĞIŞ YAP</div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'DonationItem',
  props: {
    product: {
      type: Object
    }
  },
  data() {
    return {
      price: this.product.price
    }
  },
  methods: {
    redirect(data) {
      this.$modal.show('redirect-modal', { data })
      setTimeout(() => {
        window.location.replace(data.redirect_url)
      }, 2000)
    },
    donate() {
      if (this.price < 1) {
        Swal.fire({
          title: 'Bağış tutarı minumum 1 TL olmalıdır.',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Tamam'
        })
      } else {
        this.product.price = this.price
        this.$modal.show('basket-modal', { data: this.product })
      }
    }
  },
  watch: {
    price() {
      if (this.price < 0) this.price = 5
    }
  }
}
</script>
